import React, { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

import { Preloader, ToDashboardError } from '../../components/ui';
import { useConfig } from '../../contexts/config';
import { useCurrentProject } from '../../contexts/settings';
import { RouteParams } from '../../routes/types';
import { ChangeMethodPage } from './ChangeMethodPage';

const ChangeAuthMethod = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const {
    currentProject,
    updateCurrentProject,
    currentProjectFetching,
    currentProjectType,
    error
  } = useCurrentProject(projectId);

  const { xsollaAnalytics } = useConfig();

  useEffect(() => {
    if (!error) {
      xsollaAnalytics.sendOpen('login_pa_module__change_method_open', projectId);
    }
  }, [error]);

  if (currentProjectFetching) {
    return <Preloader />;
  }

  if (error) {
    return <ToDashboardError error={error} pageName="change_method_open" />;
  }

  if (currentProject) {
    return (
      <ChangeMethodPage
        updateConfigurations={updateCurrentProject}
        configurations={currentProject}
        currentProjectType={currentProjectType}
      />
    );
  }

  return <></>;
};

export default withRouter(ChangeAuthMethod);
